var render, staticRenderFns
import script from "./WidgetInheritedRiskScore.vue?vue&type=script&lang=js&"
export * from "./WidgetInheritedRiskScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce288fc')) {
      api.createRecord('0ce288fc', component.options)
    } else {
      api.reload('0ce288fc', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/WidgetInheritedRiskScore.vue"
export default component.exports